/* eslint-disable no-unused-vars */
import PropTypes from "prop-types";
import {styled} from "@mui/material/styles";
import {FmlxIcon} from "fmlx-common-ui";

const CustomizeStepIconRoot = styled("div")(({active, completed, error}) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "1.5rem",
  height: "1.5rem",
  backgroundColor: "#888888",
  color: "#ffffff",
  borderRadius: "50%",
  fontFamily: '"Roboto", sans-serif',
  fontSize: "0.75rem",
  lineHeight: "normal",
  fontWeight: "400",
  ...(error && {backgroundColor: "transparent"}),
  ...(active && {backgroundColor: "#4caf50"}),
  ...(completed && {backgroundColor: "#4caf50"}),
  ...(error && completed && {backgroundColor: "transparent"}),
  ...(error && active && {backgroundColor: "transparent"}),
  ".MuiSvgIcon-root": {
    width: "0.75rem",
    height: "0.75rem",
    ...(error && {
      width: "1.5rem",
      height: "1.5rem",
    }),
    ".fmlx-icon": {
      fill: "#ffffff",
      ...(error && {fill: "#ff5252"}),
    },
  },
}));

const CustomizeStepIcon = ({active, completed, icon, error}) => {
  const renderContent = () => {
    let content;

    if (!active && !completed && !error) {
      content = icon;
    } else if (error) {
      content = <FmlxIcon name="Warning"/>;
    } else if (completed) {
      content = <FmlxIcon name="CheckOutline"/>;
    } else if (active) {
      content = icon;
    }

    return content;
  };

  return (
    <CustomizeStepIconRoot active={active ? 1 : 0} error={error ? 1 : 0} completed={completed ? 1 : 0}>
      {renderContent()}
    </CustomizeStepIconRoot>
  );
};

CustomizeStepIcon.propTypes = {
  active: PropTypes.bool,
  completed: PropTypes.bool,
  error: PropTypes.bool,
  icon: PropTypes.node,
};

CustomizeStepIcon.defaultProps = {
  active: false,
  completed: false,
  error: false,
  icon: null,
};

export default CustomizeStepIcon;
